import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import moment from 'moment';
import Alert from 'react-bootstrap/Alert';
import TimePicker from 'rc-time-picker';
import axios from 'axios';
import { SingleDatePicker, isInclusivelyBeforeDay, isInclusivelyAfterDay } from 'react-dates';
import { AlertSwal } from '../CustomSwal';
import { useIntl, FormattedMessage } from 'react-intl';
import '../css/timepicker.css';

function AppointmentDateS0(props) {
  const [sdate_focus, setSdate_focus] = useState(null);
  const [edate_focus, setEdate_focus] = useState(null);
  const intl = useIntl();

  const checkEdate = () => {
    let bookrealeasedays = parseInt(props.params.bookrealeasedays);
    if (bookrealeasedays === 0) {
      bookrealeasedays = 1;
    }
    let edate = moment().add((parseInt(props.params.oncecanbooktime) - 1), 'days');
    let lastdate = moment().add(bookrealeasedays - 1, 'days');
    if (edate.isAfter(lastdate, 'days')) {
      edate = lastdate;
      props.setEdate(edate);
    }
  }

  useEffect(checkEdate, []);

  const seqdays = [1, 3, 7, 10, 14];
  return (
    <Form>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label><FormattedMessage id='appointment.start_date' /></Form.Label>
          <SingleDatePicker
            id="sdate"
            date={props.sdate}
            focused={sdate_focus}
            onDateChange={(e) => {
              props.setSdate(e);
              let bookrealeasedays = parseInt(props.params.bookrealeasedays);
              if (bookrealeasedays === 0) {
                bookrealeasedays = 1;
              }
              let edate = moment(e).add((parseInt(props.params.oncecanbooktime) - 1), 'days');
              let lastdate = moment().add(bookrealeasedays - 1, 'days');
              if (edate.isAfter(lastdate, 'days')) {
                edate = lastdate;
              }
              props.setEdate(edate);
            }}
            onFocusChange={(e) => {
              setSdate_focus(e.focused);
            }}
            isOutsideRange={(day) => {
              if (props.params === null) {
                return null;
              } else {
                let bookrealeasedays = parseInt(props.params.bookrealeasedays);
                if (bookrealeasedays === 0) {
                  bookrealeasedays = 1;
                }
                return !isInclusivelyBeforeDay(day, moment().add(bookrealeasedays - 1, "days")) ||
                  !isInclusivelyAfterDay(day, moment());
              }
            }}
            placeholder=''
            displayFormat="YYYY/MM/DD"
            numberOfMonths={1}
            block
            readOnly
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label><FormattedMessage id='appointment.end_date' /></Form.Label>
          <SingleDatePicker
            id="edate"
            date={props.edate}
            focused={edate_focus}
            onDateChange={(e) => {
              props.setEdate(e);
            }}
            onFocusChange={(e) => {
              setEdate_focus(e.focused);
            }}
            placeholder=''
            displayFormat="YYYY/MM/DD"
            numberOfMonths={1}
            disabled
            block
            readOnly
          />
        </Form.Group>
      </Form.Row>
      <Form.Group>
        <Form.Label><FormattedMessage id='appointment.continuous_use' /></Form.Label>
        <Form.Control as="select" id="seqdays">
          {seqdays.map((val) => {
            if (val <= parseInt(props.params.oncecanbooktime)) {
              if (val === 1) {
                return <option key={val} value={val}> {val} {intl.formatMessage({ id: 'global.day' })}</option>
              }
              return <option key={val} value={val}> {val} {intl.formatMessage({ id: 'global.days' })}</option>
            }
            return null;
          })}
        </Form.Control>
      </Form.Group>
    </Form>
  )
}

function AppointmentDateS1(props) {
  const [checked, setChecked] = useState('');

  const handleCheck = (i) => {
    setChecked(i);
  }

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  return (
    <Row className={"deviceArea " + props.formType}>
      {props.messages.appointment.zone_info[props.selectedzone.zoneid] ?
        <Col sm={12}>
          <Alert variant='danger' className='mb-2'><FormattedMessage id={`appointment.zone_info.${props.selectedzone.zoneid}`} /></Alert>
        </Col>
        : null}
      {props.data === null ? <Col sm={12}>Loading</Col> :
        props.data.length === 0 ? <Col sm={12}>No Data Found</Col> :
          props.data.map((row, index) => {
            const isChecked = checked === row.deviceid ? true : false;
            const isMac = props.config.IS_MAC_DEVICEID.find(elem => elem === row.deviceid) ? true : false;
            return (
              <Col key={row.deviceid} xs={12} sm={6} md={4} lg={3} xl={2}>
                <Card border="dark" onClick={() => { handleCheck(row.deviceid); }}>
                  <Card.Body className="d-flex justify-content-around align-items-center">
                    <div className='device_left'>
                      {(row.deviceinfo !== '' && row.deviceinfo !== null) ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              {row.deviceinfo}
                            </Tooltip>
                          }
                        >
                          <i className='information-icon deviceinfo-icon'></i>
                        </OverlayTrigger>
                        : null}
                      {(row.deviceusetype === '4') ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              <FormattedMessage id='appointment.accessibility_space' />
                            </Tooltip>
                          }
                        >
                          <i className='deviceinfo-icon accessibility-icon'></i>
                        </OverlayTrigger>
                        : null}
                    </div>
                    <div className="text-center device_info">
                      <b>{row.devicename} {row.userCount ? <span className='d-inline-block'><FormattedMessage id='appointment.user_count' values={{ value: row.userCount }} /></span> : null}</b><br />
                      {(isMac) ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              <FormattedMessage id='appointment.mac_device' />
                            </Tooltip>
                          }
                        >
                          <div style={{ margin: '-5px 0 0 -6px' }}>
                            <i className='deviceinfo-icon mac-icon'></i>
                          </div>
                        </OverlayTrigger>
                        : null}
                      <b className="device_usetype">
                        {row.maxcanbookdays + ' '}
                        {row.maxcanbookdays === '1' ?
                          <FormattedMessage id='global.day' />
                          : <FormattedMessage id='global.days' />}
                      </b>
                    </div>
                    <div>
                      <Form.Check type="radio" name="deviceid" value={row.deviceid} aria-label={`deviceid_${row.deviceid}`} checked={isChecked} readOnly />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )
          })
      }
    </Row >
  )
}

function AppointmentDateS2(props) {
  const [checked, setChecked] = useState([]);
  const intl = useIntl();

  const handleCheck = (i) => {
    // 若 i 已勾選
    if (checked.find(elem => elem === i)) {
      // 取消勾選 i 及 i 以後的日期時間
      setChecked(checked.filter(elem => elem !== i && parseInt(elem) < parseInt(i)));
    } else {
      // 若 i 未勾選
      let newState = [];
      // 若目前有任何勾選 && 若 i 大於目前已勾選的最小值
      if (checked.length !== 0 && parseInt(i) > parseInt(checked[0])) {
        let cantBookInMiddle = null
        // 勾選所有 i 與 最小值之間的選項
        props.data.map((row, index) => {
          if (parseInt(row.bookvalue) <= parseInt(i) && parseInt(row.bookvalue) >= parseInt(checked[0])) {
            // 中間有無法預約的時段，同時必須是第一個 ，記錄該 index
            if (row.canbook === '0' && cantBookInMiddle === null) {
              cantBookInMiddle = newState.length;
            }
            newState.push(row.bookvalue);
          }
          return null;
        })
        // 刪掉 index 後的 elem
        if (cantBookInMiddle) {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: intl.formatMessage({ id: 'appointment.alert.middle_duplicate' }),
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
          newState = newState.splice(0, cantBookInMiddle);
        }
        // 刪掉超過最大天數的 elem
        if (newState.length > parseInt(props.params.oncecanbooktime)) {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' }),
            html:
              `<span>` +
              intl.formatMessage({ id: 'appointment.alert.reach_max_date' }) +
              `<span class='d-inline-block'>` +
              intl.formatMessage({ id: 'appointment.alert.reach_max_date_value' }, {
                value: props.params.oncecanbooktime
              }) + `</span></span>`
          });
          const delCount = newState.length - parseInt(props.params.oncecanbooktime);
          newState.splice(newState.length - delCount, newState.length)
        }
      } else {
        // 若未有任何勾選 || 若 i 小於最小值 
        // 只改為勾選 i
        newState.push(i);
      }
      // setChecked(prevState => [...prevState, i]);
      setChecked(newState);
    }
  }

  return (
    <Row className="deviceArea">
      <Col sm={12}>
        <Alert variant='danger' className='mb-2'>
          <FormattedMessage id='appointment.max_value' />
          {
            props.params.oncecanbooktime === '1' ?
              <FormattedMessage id='appointment.alert.reach_max_date_value' values={{ value: props.params.oncecanbooktime }} />
              :
              <FormattedMessage id='appointment.alert.reach_max_date_values' values={{ value: props.params.oncecanbooktime }} />
          }
        </Alert>
      </Col>
      {props.data === null ? <Col sm={12}>Loading</Col> :
        props.data.length === 0 ? <Col sm={12}>No Data Found</Col> :
          props.data.map((row, index) => {
            const isChecked = checked.find(elem => elem === row.bookvalue) ? true : false;
            return (
              <Col key={row.bookvalue} xs={12} sm={6} md={4} lg={3} xl={2}>
                <Card border="dark" onClick={() => { handleCheck(row.bookvalue); }} className={row.canbook === '0' ? 'disabled' : null}>
                  <Card.Body className="d-flex justify-content-around align-items-center">
                    <div className="text-center device_info">
                      <b>{row.bookdate}</b>
                    </div>
                    <div>
                      <Form.Check viewvalue={row.bookdate} name="bookvalue" value={row.bookvalue} aria-label={`bookvalue_${row.bookvalue}`} checked={isChecked} readOnly disabled={(row.canbook === '0')} />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )
          })}
    </Row>
  )
}

function AppointmentTimeS0(props) {
  const [sdate_focus, setSdate_focus] = useState(null);
  const [opentime, setOpentime] = useState('00:00');
  const [closetime, setClosetime] = useState('00:00');
  const sid = sessionStorage.getItem('sid');
  const authid = sessionStorage.getItem('authid');
  const config = props.config;
  const intl = useIntl();

  const GetOpenTime = () => {
    props.setLoading(true);
    axios.get(config.API_URL + `/GetOpenTime.aspx`, {
      params: {
        sid: sid,
        authid: authid,
        spacetype: props.selectedzone.spacetype,
        bookdate: props.sdate.format('YYYY/MM/DD'),
        restype: 'json'
      }
    }).then((res) => {
      const data = res.data[0];
      if (data.rescode === '3' || data.rescode === '4') {
        props.setSession(false);
      } else {
        if (data.rescode === '1') {
          // setOpentime(data.resdata[0].opentime);
          // setClosetime(data.resdata[0].closetime);
          setOpentime(data.resdata[0].opentime);
          setClosetime(data.resdata[0].closetime);
        } else {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: data.resmsg,
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
        }
      }
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      props.setLoading(false);
    })
  }

  function generateOptions(length, excludedOptions) {
    const arr = [];
    for (let value = 0; value < length; value++) {
      if (excludedOptions.indexOf(value) >= 0) {
        arr.push(value);
      }
    }
    return arr;
  }

  function disabledHours() {
    const openHour = parseInt(opentime.split(':')[0]);
    const closeHour = parseInt(closetime.split(':')[0]);
    if (opentime === '00:00' && closetime === '00:00') {
      return [];
    } else {
      let temp = [];
      for (let index = 0; index < openHour; index++) {
        temp.push(index);
      }
      for (let index = 23; index > closeHour; index--) {
        temp.push(index);
      }
      return temp;
    }
  }

  function disabledMinutes(h) {
    const openHour = parseInt(opentime.split(':')[0]);
    const closeHour = parseInt(closetime.split(':')[0]);
    let temp = [];
    for (let index = 0; index < parseInt(opentime.split(':')[1]); index++) {
      temp.push(index);
    }
    let temp2 = [];
    for (let index = (parseInt(closetime.split(':')[1]) + 1); index < 60; index++) {
      temp2.push(index);
    }
    if (opentime === '00:00' && closetime === '00:00') {
      return [];
    } else {
      switch (h) {
        case openHour:
          return generateOptions(60, temp);
        case closeHour:
          return generateOptions(60, temp2);
        default:
          return generateOptions(60, []);
      }
    }
  }

  const handleDateChange = () => {
    const now = moment();
    const openHour = parseInt(opentime.split(':')[0]);
    const openMinute = parseInt(opentime.split(':')[1]);
    const openMoment = moment().hour(openHour).minute(openMinute);
    if (props.sdate.isSame(now, 'day') && now.isAfter(openMoment)) {
      let roundedNow;
      if (now.minute() >= 30) {
        roundedNow = now.minute(30).second(0);
      } else {
        roundedNow = now.minute(0).second(0);
      }
      props.setStime(roundedNow.format("HH:mm"));
    } else {
      props.setStime(opentime);
    }
    if (closetime === '00:00') {
      props.setEtime(moment('23:30', 'HH:mm').format("HH:mm"));
    } else {
      props.setEtime(closetime);
    }
  }

  useEffect(GetOpenTime, []);

  useEffect(handleDateChange, [props.sdate, closetime]);

  return (
    <Form>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label><FormattedMessage id='appointment.select_date' /></Form.Label>
          <SingleDatePicker
            id="sdate"
            date={props.sdate}
            focused={sdate_focus}
            onDateChange={(e) => {
              props.setSdate(e);
            }}
            onFocusChange={(e) => {
              setSdate_focus(e.focused);
            }}
            isOutsideRange={(day) => {
              if (props.params === null) {
                return null;
              } else {
                let bookrealeasedays = parseInt(props.params.bookrealeasedays);
                if (bookrealeasedays === 0) {
                  bookrealeasedays = 1;
                }
                return !isInclusivelyBeforeDay(day, moment().add(bookrealeasedays - 1, "days")) ||
                  !isInclusivelyAfterDay(day, moment());
              }
            }}
            placeholder=''
            displayFormat="YYYY/MM/DD"
            numberOfMonths={1}
            block
            readOnly
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label><FormattedMessage id='appointment.start_time' /></Form.Label>
          <TimePicker
            hideDisabledOptions
            allowEmpty={false}
            showSecond={false}
            minuteStep={30}
            value={moment(props.stime, "HH:mm")}
            onChange={(val) => { props.setStime(moment(val).format("HH:mm")); }}
            disabledHours={disabledHours}
            disabledMinutes={disabledMinutes}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label><FormattedMessage id='appointment.end_time' /></Form.Label>
          <TimePicker
            hideDisabledOptions
            allowEmpty={false}
            showSecond={false}
            minuteStep={30}
            value={moment(props.etime, "HH:mm")}
            onChange={(val) => { props.setEtime(moment(val).format("HH:mm")); }}
            disabledHours={disabledHours}
            disabledMinutes={disabledMinutes}
          />
        </Form.Group>
      </Form.Row>
    </Form>
  )
}

function AppointmentTimeS1(props) {
  const [checked, setChecked] = useState('');

  const handleCheck = (i) => {
    setChecked(i);
  }

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  return (
    <Row className={"deviceArea " + props.formType}>
      {props.messages.appointment.zone_info[props.selectedzone.zoneid] ?
        <Col sm={12}>
          <Alert variant='danger' className='mb-2'><FormattedMessage id={`appointment.zone_info.${props.selectedzone.zoneid}`} /></Alert>
        </Col>
        : null}
      {props.data === null ? <Col sm={12}>Loading</Col> :
        props.data.length === 0 ? <Col sm={12}>No Data Found</Col> :
          props.data.map((row, index) => {
            const isChecked = checked === row.deviceid ? true : false;
            const isMac = props.config.IS_MAC_DEVICEID.find(elem => elem === row.deviceid) ? true : false;
            return (
              <Col key={row.deviceid} xs={12} sm={6} md={4} lg={3} xl={2}>
                <Card border="dark" onClick={() => { handleCheck(row.deviceid); }}>
                  <Card.Body className="d-flex justify-content-around align-items-center">
                    <div className='device_left'>
                      {(row.deviceinfo !== '' && row.deviceinfo !== null) ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              {row.deviceinfo}
                            </Tooltip>
                          }
                        >
                          <i className='deviceinfo-icon information-icon'></i>
                        </OverlayTrigger>
                        : null}
                      {(row.deviceusetype === '4') ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              <FormattedMessage id='appointment.accessibility_space' />
                            </Tooltip>
                          }
                        >
                          <i className='deviceinfo-icon accessibility-icon'></i>
                        </OverlayTrigger>
                        : null}
                    </div>
                    <div className="text-center device_info">
                      <b>{row.devicename} {row.userCount ? <span className='d-inline-block'><FormattedMessage id='appointment.user_count' values={{ value: row.userCount }} /></span> : null}</b>
                      {(isMac) ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              <FormattedMessage id='appointment.mac_device' />
                            </Tooltip>
                          }
                        >
                          <div style={{ margin: '-5px 0 0 -6px' }}>
                            <i className='deviceinfo-icon mac-icon'></i>
                          </div>
                        </OverlayTrigger>
                        : null}
                    </div>
                    <div>
                      <Form.Check type="radio" name="deviceid" value={row.deviceid} aria-label={`deviceid_${row.deviceid}`} checked={isChecked} readOnly />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )
          })
      }
    </Row>
  )
}

function AppointmentTimeS2(props) {
  const [checked, setChecked] = useState([]);
  const intl = useIntl();

  const handleCheck = (i) => {
    // 若 i 已勾選
    if (checked.find(elem => elem === i)) {
      // 取消勾選 i 及 i 以後的日期時間
      setChecked(checked.filter(elem => elem !== i && parseInt(elem) < parseInt(i)));
    } else {
      // 若 i 未勾選
      let newState = [];
      // 若目前有任何勾選 && 若 i 大於目前已勾選的最小值
      if (checked.length !== 0 && parseInt(i) > parseInt(checked[0])) {
        let cantBookInMiddle = null
        // 勾選所有 i 與 最小值之間的選項
        props.data.map((row, index) => {
          if (parseInt(row.bookvalue) <= parseInt(i) && parseInt(row.bookvalue) >= parseInt(checked[0])) {
            if (row.canbook === '0' && cantBookInMiddle === null) {
              cantBookInMiddle = newState.length;
            }
            newState.push(row.bookvalue);
          }
          return null;
        })
        if (cantBookInMiddle) {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: intl.formatMessage({ id: 'appointment.alert.middle_duplicate' }),
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
          newState = newState.splice(0, cantBookInMiddle);
        }
        if ((newState.length / 2) > parseInt(props.params.oncecanbooktime)) {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' }),
            html:
              `<span>` +
              intl.formatMessage({ id: 'appointment.alert.reach_max_time' }) +
              `<span class='d-inline-block'>` +
              intl.formatMessage({ id: 'appointment.alert.reach_max_time_value' }, {
                value: props.params.oncecanbooktime
              }) + `</span></span>`
          });
          let delCount = ((newState.length / 2) - parseInt(props.params.oncecanbooktime)) * 2;
          newState.splice(newState.length - delCount, newState.length)
        }
      } else {
        // 若未有任何勾選 || 若 i 小於最小值 
        // 只改為勾選 i
        newState.push(i);
      }
      // setChecked(prevState => [...prevState, i]);
      setChecked(newState);
    }
  }

  return (
    <Row className="deviceArea">
      <Col sm={12}>
        <Alert variant='danger' className='mb-2'>
          <FormattedMessage id='appointment.max_value' />
          {
            props.params.oncecanbooktime === '1' ?
              <FormattedMessage id='appointment.alert.reach_max_time_value' values={{ value: props.params.oncecanbooktime }} />
              :
              <FormattedMessage id='appointment.alert.reach_max_time_value' values={{ value: props.params.oncecanbooktime }} />
          }
        </Alert>
      </Col>
      {props.data === null ? <Col sm={12}>Loading</Col> :
        props.data.length === 0 ? <Col sm={12}>No Data Found</Col> :
          props.data.map((row, index) => {
            const isChecked = checked.find(elem => elem === row.bookvalue) ? true : false;
            return (
              <Col key={row.bookvalue} xs={12} sm={6} md={4} lg={3} xl={2}>
                <Card border="dark" onClick={() => { handleCheck(row.bookvalue); }} className={row.canbook === '0' ? 'disabled' : null}>
                  <Card.Body className="d-flex justify-content-around align-items-center">
                    <div className="text-center device_info">
                      <b>{row.booktime}</b>
                    </div>
                    <div>
                      <Form.Check viewvalue={row.booktime} name="bookvalue" value={row.bookvalue} aria-label={`bookvalue_${row.bookvalue}`} checked={isChecked} readOnly disabled={(row.canbook === '0')} />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )
          })
      }
    </Row>
  )
}

function AppointmentNightS0(props) {
  const [sdate_focus, setSdate_focus] = useState(null);
  const [opentime, setOpentime] = useState('00:00');
  const [closetime, setClosetime] = useState('00:00');
  const sid = sessionStorage.getItem('sid');
  const authid = sessionStorage.getItem('authid');
  const config = props.config;
  const intl = useIntl();

  const GetOpenTime = () => {
    props.setLoading(true);
    axios.get(config.API_URL + `/GetOpenTime.aspx`, {
      params: {
        sid: sid,
        authid: authid,
        spacetype: props.selectedzone.spacetype,
        bookdate: props.sdate.format('YYYY/MM/DD'),
        restype: 'json'
      }
    }).then((res) => {
      const data = res.data[0];
      if (data.rescode === '3' || data.rescode === '4') {
        props.setSession(false);
      } else {
        if (data.rescode === '1') {
          setOpentime(data.resdata[0].opentime);
          setClosetime(data.resdata[0].closetime);
        } else {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: data.resmsg,
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
        }
      }
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      props.setLoading(false);
    })
  }

  function generateOptions(length, excludedOptions) {
    const arr = [];
    for (let value = 0; value < length; value++) {
      if (excludedOptions.indexOf(value) >= 0) {
        arr.push(value);
      }
    }
    return arr;
  }

  function disabledHours() {
    // const openHour = parseInt(opentime.split(':')[0]);
    // const closeHour = parseInt(closetime.split(':')[0]);
    // if (opentime === '00:00' && closetime === '00:00') {
    //   return [];
    // } else {
    //   let temp = [];
    //   for (let index = 0; index < 24; index++) {
    //     if (index < openHour && index > closeHour) {
    //       temp.push(index);
    //     }
    //   }
    //   return temp;
    // }
    return [];
  }

  function disabledMinutes(h) {
    const openHour = parseInt(opentime.split(':')[0]);
    const closeHour = parseInt(closetime.split(':')[0]);
    let temp = [];
    for (let index = 0; index < parseInt(opentime.split(':')[1]); index++) {
      temp.push(index);
    }
    let temp2 = [];
    for (let index = (parseInt(closetime.split(':')[1]) + 1); index < 60; index++) {
      temp2.push(index);
    }
    if (opentime === '00:00' && closetime === '00:00') {
      return [];
    } else {
      switch (h) {
        case openHour:
          return generateOptions(60, temp);
        case closeHour:
          return generateOptions(60, temp2);
        default:
          return generateOptions(60, []);
      }
    }
  }

  const handleDateChange = () => {
    const now = moment();
    const openHour = parseInt(opentime.split(':')[0]);
    const openMinute = parseInt(opentime.split(':')[1]);
    const openMoment = moment().hour(openHour).minute(openMinute);
    if (props.sdate.isSame(now, 'day') && now.isAfter(openMoment)) {
      let roundedNow;
      if (now.minute() >= 30) {
        roundedNow = now.minute(30).second(0);
      } else {
        roundedNow = now.minute(0).second(0);
      }
      props.setStime(roundedNow.format("HH:mm"));
    } else {
      props.setStime(opentime);
    }
    props.setEtime(closetime);
  }

  useEffect(GetOpenTime, []);

  useEffect(handleDateChange, [props.sdate, closetime]);

  return (
    <Form>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label><FormattedMessage id='appointment.select_date' /></Form.Label>
          <SingleDatePicker
            id="sdate"
            date={props.sdate}
            focused={sdate_focus}
            onDateChange={(e) => {
              props.setSdate(e);
            }}
            onFocusChange={(e) => {
              setSdate_focus(e.focused);
            }}
            isOutsideRange={(day) => {
              if (props.params === null) {
                return null;
              } else {
                let bookrealeasedays = parseInt(props.params.bookrealeasedays);
                if (bookrealeasedays === 0) {
                  bookrealeasedays = 1;
                }
                return !isInclusivelyBeforeDay(day, moment().add(bookrealeasedays - 1, "days")) ||
                  !isInclusivelyAfterDay(day, moment());
              }
            }}
            placeholder=''
            displayFormat="YYYY/MM/DD"
            numberOfMonths={1}
            block
            readOnly
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label><FormattedMessage id='appointment.start_time' /></Form.Label>
          <TimePicker
            hideDisabledOptions
            allowEmpty={false}
            showSecond={false}
            minuteStep={30}
            value={moment(props.stime, "HH:mm")}
            onChange={(val) => { props.setStime(moment(val).format("HH:mm")); }}
            disabledHours={disabledHours}
            disabledMinutes={disabledMinutes}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label><FormattedMessage id='appointment.end_time' /></Form.Label>
          <TimePicker
            hideDisabledOptions
            allowEmpty={false}
            showSecond={false}
            minuteStep={30}
            value={moment(props.etime, "HH:mm")}
            onChange={(val) => { props.setEtime(moment(val).format("HH:mm")); }}
            disabledHours={disabledHours}
            disabledMinutes={disabledMinutes}
          />
        </Form.Group>
      </Form.Row>
    </Form>
  )
}

function AppointmentNightS1(props) {
  const [checked, setChecked] = useState('');

  const handleCheck = (i) => {
    setChecked(i);
  }

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  return (
    <Row className={"deviceArea " + props.formType}>
      {props.messages.appointment.zone_info[props.selectedzone.zoneid] ?
        <Col sm={12}>
          <Alert variant='danger' className='mb-2'><FormattedMessage id={`appointment.zone_info.${props.selectedzone.zoneid}`} /></Alert>
        </Col>
        : null}
      {props.data === null ? <Col sm={12}>Loading</Col> :
        props.data.length === 0 ? <Col sm={12}>No Data Found</Col> :
          props.data.map((row, index) => {
            const isChecked = checked === row.deviceid ? true : false;
            const isMac = props.config.IS_MAC_DEVICEID.find(elem => elem === row.deviceid) ? true : false;
            return (
              <Col key={row.deviceid} xs={12} sm={6} md={4} lg={3} xl={2}>
                <Card border="dark" onClick={() => { handleCheck(row.deviceid); }}>
                  <Card.Body className="d-flex justify-content-around align-items-center">
                    <div className='device_left'>
                      {(row.deviceinfo !== '' && row.deviceinfo !== null) ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              {row.deviceinfo}
                            </Tooltip>
                          }
                        >
                          <i className='deviceinfo-icon information-icon'></i>
                        </OverlayTrigger>
                        : null}
                      {(row.deviceusetype === '4') ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              <FormattedMessage id='appointment.accessibility_space' />
                            </Tooltip>
                          }
                        >
                          <i className='deviceinfo-icon accessibility-icon'></i>
                        </OverlayTrigger>
                        : null}
                    </div>
                    <div className="text-center device_info">
                      <b>{row.devicename} {row.userCount ? <span className='d-inline-block'><FormattedMessage id='appointment.user_count' values={{ value: row.userCount }} /></span> : null}</b>
                      {(isMac) ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              <FormattedMessage id='appointment.mac_device' />
                            </Tooltip>
                          }
                        >
                          <div style={{ margin: '-5px 0 0 -6px' }}>
                            <i className='deviceinfo-icon mac-icon'></i>
                          </div>
                        </OverlayTrigger>
                        : null}
                    </div>
                    <div>
                      <Form.Check type="radio" name="deviceid" value={row.deviceid} aria-label={`deviceid_${row.deviceid}`} checked={isChecked} readOnly />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )
          })
      }
    </Row>
  )
}

function AppointmentNightS2(props) {
  const [checked, setChecked] = useState([]);
  const intl = useIntl();

  const handleCheck = (i) => {
    // 若 i 已勾選
    if (checked.find(elem => elem === i)) {
      // 取消勾選 i 及 i 以後的日期時間
      setChecked(checked.filter(elem => elem !== i && parseInt(elem) < parseInt(i)));
    } else {
      // 若 i 未勾選
      let newState = [];
      // 若目前有任何勾選 && 若 i 大於目前已勾選的最小值
      if (checked.length !== 0 && parseInt(i) > parseInt(checked[0])) {
        let cantBookInMiddle = null
        // 勾選所有 i 與 最小值之間的選項
        props.data.map((row, index) => {
          if (parseInt(row.bookvalue) <= parseInt(i) && parseInt(row.bookvalue) >= parseInt(checked[0])) {
            if (row.canbook === '0' && cantBookInMiddle === null) {
              cantBookInMiddle = newState.length;
            }
            newState.push(row.bookvalue);
          }
          return null;
        })
        if (cantBookInMiddle) {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: intl.formatMessage({ id: 'appointment.alert.middle_duplicate' }),
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
          newState = newState.splice(0, cantBookInMiddle);
        }
        if ((newState.length / 2) > parseInt(props.params.oncecanbooktime)) {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' }),
            html:
              `<span>` +
              intl.formatMessage({ id: 'appointment.alert.reach_max_time' }) +
              `<span class='d-inline-block'>` +
              intl.formatMessage({ id: 'appointment.alert.reach_max_time_value' }, {
                value: props.params.oncecanbooktime
              }) + `</span></span>`
          });
          let delCount = ((newState.length / 2) - parseInt(props.params.oncecanbooktime)) * 2;
          newState.splice(newState.length - delCount, newState.length)
        }
      } else {
        // 若未有任何勾選 || 若 i 小於最小值 
        // 只改為勾選 i
        newState.push(i);
      }
      // setChecked(prevState => [...prevState, i]);
      setChecked(newState);
    }
  }

  // let prevDate = '';
  return (
    <Row className="deviceArea">
      <Col sm={12}>
        <Alert variant='danger' className='mb-2'>
          <FormattedMessage id='appointment.max_value' />
          {
            props.params.oncecanbooktime === '1' ?
              <FormattedMessage id='appointment.alert.reach_max_time_value' values={{ value: props.params.oncecanbooktime }} />
              :
              <FormattedMessage id='appointment.alert.reach_max_time_value' values={{ value: props.params.oncecanbooktime }} />
          }
        </Alert>
      </Col>
      {props.data === null ? <Col sm={12}>Loading</Col> :
        props.data.length === 0 ? <Col sm={12}>No Data Found</Col> :
          props.data.map((row, index) => {
            // let showDate = null;
            // if (prevDate !== row.bookdate) {
            //   showDate = <small>{row.bookdate}</small>;
            //   prevDate = row.bookdate;
            // }
            const isChecked = checked.find(elem => elem === row.bookvalue) ? true : false;
            return (
              <Col key={row.bookvalue} xs={12} sm={6} md={4} lg={3} xl={2}>
                <Card border="dark" onClick={() => { handleCheck(row.bookvalue); }} className={row.canbook === '0' ? 'disabled' : null}>
                  <Card.Body className="d-flex justify-content-around align-items-center">
                    <div className="text-center device_info">
                      <b>{row.booktime}</b>
                      {/* {showDate} */}
                    </div>
                    <div>
                      <Form.Check viewdate={row.bookdate} viewvalue={row.booktime} name="bookvalue" value={row.bookvalue} aria-label={`bookvalue_${row.bookvalue}`} checked={isChecked} readOnly disabled={(row.canbook === '0')} />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )
          })
      }
    </Row>
  )
}

function AppointmentMultiple(props) {
  const handleInput = (elem) => {
    let newState = [...props.userids];
    newState[elem.target.getAttribute('idx')] = elem.target.value;
    props.setUserids(newState);
  }

  let useridsForm = [];
  for (let index = 0; index < (props.formUserNumber - 1); index++) {
    useridsForm.push(
      <Form.Group as={Col} sm={12} md={6} key={index}>
        <Form.Label><FormattedMessage id='global.reader_id' /></Form.Label>
        <Form.Control value={props.userids[index] ? props.userids[index] : ''} idx={index} onChange={handleInput} />
      </Form.Group>
    );
  }

  return (
    <Form>
      <Alert variant='danger'>
        <FormattedMessage id='appointment.multiple_tips.row_1' />
        <br />
        <FormattedMessage id='appointment.multiple_tips.row_2' values={{ value: (props.formUserNumber - 1) }} />
      </Alert>
      <Form.Row>
        {useridsForm}
      </Form.Row>
    </Form>
  )
}

export {
  AppointmentDateS0,
  AppointmentDateS1,
  AppointmentDateS2,
  AppointmentTimeS0,
  AppointmentTimeS1,
  AppointmentTimeS2,
  AppointmentNightS0,
  AppointmentNightS1,
  AppointmentNightS2,
  AppointmentMultiple
};